import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { MainContainer, EditButton, EditContainer, SaveButton, CancelButton, ProfileContainerInfo, FormContainer, Row, Label, ShowInput, ButtonContainer, RightColumn, LeftColumn } from './styles';
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import { engineeringService } from '../../../services/engineeringService';

const AdditionalInformation = ({ project_id, matchObjectId }) => {
  const collapsed = useSelector((state) => state.sidebar);

  const [fileStates, setFileStates] = useState({
    metodologia: '',
    tipo_de_projeto: '',
    tipo_de_ativo: '',
    data_de_emissao: '',
    additional_information: '',
    responsavel_projeto: '',
    duracao_projeto: '',
    certificadora: '',
  });

  const [engineeringId, setEngineeringId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [hasData, setHasData] = useState(false);

  useEffect(() => {
    const fetchEngineeringData = async () => {
      try {
        const token = sessionStorage.getItem('Authorization');

        if (!token) {
          console.error('❌ Token não encontrado no sessionStorage');
          return;
        }

        const responseData = await engineeringService.getEngineeringByProjectId(matchObjectId, token);

        setEngineeringId(responseData.id);

        const newFileStates = {
          metodologia: responseData.metodologia || '',
          tipo_de_projeto: responseData.tipo_de_projeto || '',
          tipo_de_ativo: responseData.tipo_de_ativo || '',
          data_de_emissao: responseData.data_de_emissao || '',
          additional_information: responseData.additional_information || '',
          responsavel_projeto: responseData.responsavel_projeto || '',
          duracao_projeto: responseData.duracao_projeto || '',
          certificadora: responseData.certificadora || '',
        };

        setFileStates(newFileStates);

        // Verificar se há dados preenchidos
        const hasAnyData = Object.values(newFileStates).some(value => value !== '');
        setHasData(hasAnyData);

        // Se não há dados, permitir edição automaticamente
        if (!hasAnyData) {
          setIsEditing(true);
        }

      } catch (error) {
        console.error('❌ Erro ao carregar dados de engenharia:', error);
        // Se der erro (não encontrou dados), permitir edição
        setIsEditing(true);
      }
    };

    if (matchObjectId) {
      fetchEngineeringData();
    }
  }, [matchObjectId]);

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleCancel = () => {
    setIsEditing(false);
    // Recarregar os dados originais (você pode implementar isso salvando os dados originais em outro estado)
  };

  const handleUpload = async () => {
    try {
      if (!engineeringId) {
        Swal.fire({
          title: 'Erro!',
          text: 'Registro de engenharia não encontrado. Recarregue a página.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
        return;
      }

      const formData = new FormData();
      formData.append('project', project_id);

      if (fileStates.metodologia) formData.append('metodologia', fileStates.metodologia);
      if (fileStates.tipo_de_projeto) formData.append('tipo_de_projeto', fileStates.tipo_de_projeto);
      if (fileStates.tipo_de_ativo) formData.append('tipo_de_ativo', fileStates.tipo_de_ativo);
      if (fileStates.data_de_emissao) formData.append('data_de_emissao', fileStates.data_de_emissao);
      if (fileStates.additional_information) formData.append('additional_information', fileStates.additional_information);
      if (fileStates.responsavel_projeto) formData.append('responsavel_projeto', fileStates.responsavel_projeto);
      if (fileStates.duracao_projeto) formData.append('duracao_projeto', fileStates.duracao_projeto);
      if (fileStates.certificadora) formData.append('certificadora', fileStates.certificadora);

      const token = sessionStorage.getItem('Authorization');

      await engineeringService.updateEngineering(engineeringId, formData, token);

      Swal.fire({
        title: 'Sucesso!',
        text: 'Seus dados foram salvos com sucesso!',
        icon: 'success',
        confirmButtonText: 'OK'
      });

      // Desabilitar edição após salvar
      setIsEditing(false);
      setHasData(true);

    } catch (error) {
      console.error('❌ Upload failed!', error);
      Swal.fire({
        title: 'Erro!',
        text: 'Algo deu errado. Por favor, contate nosso suporte! suporte@vertecotech.com',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    }
  };

  return (
    <MainContainer>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.8 }}
      >
        <ProfileContainerInfo collapsed={collapsed}>
          <h2>Informações PDD</h2>
          <FormContainer>
            <LeftColumn>
              <Row>
                <Label htmlFor="metodologia">
                  Metodologia
                </Label>
                <ShowInput
                  type="text"
                  id="metodologia"
                  name="metodologia"
                  value={fileStates.metodologia}
                  onChange={(e) => setFileStates({ ...fileStates, metodologia: e.target.value })}
                  disabled={!isEditing}
                  style={{
                    backgroundColor: !isEditing ? 'var(--surface-2)' : 'var(--input-bg)',
                    cursor: !isEditing ? 'not-allowed' : 'text'
                  }}
                />
              </Row>

              <Row>
                <Label htmlFor="tipo_de_projeto">
                  Tipo de Projeto
                </Label>
                <ShowInput
                  type="text"
                  id="tipo_de_projeto"
                  name="tipo_de_projeto"
                  value={fileStates.tipo_de_projeto}
                  onChange={(e) => setFileStates({ ...fileStates, tipo_de_projeto: e.target.value })}
                  disabled={!isEditing}
                  style={{
                    backgroundColor: !isEditing ? 'var(--surface-2)' : 'var(--input-bg)',
                    cursor: !isEditing ? 'not-allowed' : 'text'
                  }}
                />
              </Row>

              <Row>
                <Label htmlFor="tipo_de_ativo">
                  Tipo de Ativo
                </Label>
                <ShowInput
                  type="text"
                  id="tipo_de_ativo"
                  name="tipo_de_ativo"
                  value={fileStates.tipo_de_ativo}
                  onChange={(e) => setFileStates({ ...fileStates, tipo_de_ativo: e.target.value })}
                  disabled={!isEditing}
                  style={{
                    backgroundColor: !isEditing ? 'var(--surface-2)' : 'var(--input-bg)',
                    cursor: !isEditing ? 'not-allowed' : 'text'
                  }}
                />
              </Row>

              <Row>
                <Label htmlFor="data_de_emissao">
                  Data de Emissão
                </Label>
                <ShowInput
                  type="text"
                  id="data_de_emissao"
                  name="data_de_emissao"
                  value={fileStates.data_de_emissao}
                  onChange={(e) => setFileStates({ ...fileStates, data_de_emissao: e.target.value })}
                  disabled={!isEditing}
                  style={{
                    backgroundColor: !isEditing ? 'var(--surface-2)' : 'var(--input-bg)',
                    cursor: !isEditing ? 'not-allowed' : 'text'
                  }}
                />
              </Row>

            </LeftColumn>

            <RightColumn>
              <Row>
                <Label htmlFor="additional_information">
                  Informações adicionais
                </Label>
                <ShowInput
                  type="text"
                  id="additional_information"
                  name="additional_information"
                  value={fileStates.additional_information}
                  onChange={(e) => setFileStates({ ...fileStates, additional_information: e.target.value })}
                  disabled={!isEditing}
                  style={{
                    backgroundColor: !isEditing ? 'var(--surface-2)' : 'var(--input-bg)',
                    cursor: !isEditing ? 'not-allowed' : 'text'
                  }}
                />
              </Row>

              <Row>
                <Label htmlFor="responsavel_projeto">
                  Responsável do Projeto
                </Label>
                <ShowInput
                  type="text"
                  id="responsavel_projeto"
                  name="responsavel_projeto"
                  value={fileStates.responsavel_projeto}
                  onChange={(e) => setFileStates({ ...fileStates, responsavel_projeto: e.target.value })}
                  disabled={!isEditing}
                  style={{
                    backgroundColor: !isEditing ? 'var(--surface-2)' : 'var(--input-bg)',
                    cursor: !isEditing ? 'not-allowed' : 'text'
                  }}
                />
              </Row>

              <Row>
                <Label htmlFor="duracao_projeto">
                  Duração do Projeto
                </Label>
                <ShowInput
                  type="text"
                  id="duracao_projeto"
                  name="duracao_projeto"
                  value={fileStates.duracao_projeto}
                  onChange={(e) => setFileStates({ ...fileStates, duracao_projeto: e.target.value })}
                  disabled={!isEditing}
                  style={{
                    backgroundColor: !isEditing ? 'var(--surface-2)' : 'var(--input-bg)',
                    cursor: !isEditing ? 'not-allowed' : 'text'
                  }}
                />
              </Row>

              <Row>
                <Label htmlFor="certificadora">
                  Certificadora
                </Label>
                <ShowInput
                  type="text"
                  id="certificadora"
                  name="certificadora"
                  value={fileStates.certificadora}
                  onChange={(e) => setFileStates({ ...fileStates, certificadora: e.target.value })}
                  disabled={!isEditing}
                  style={{
                    backgroundColor: !isEditing ? 'var(--surface-2)' : 'var(--input-bg)',
                    cursor: !isEditing ? 'not-allowed' : 'text'
                  }}
                />
              </Row>
            </RightColumn>
          </FormContainer>


          {hasData && !isEditing && (
            <EditContainer>
              <EditButton
                onClick={handleEdit}
              >
                ✏️ Editar
              </EditButton>
            </EditContainer>
          )}

          {isEditing && (
            <ButtonContainer>
              <SaveButton
                type="button"
                onClick={handleUpload}
              >
                💾 Salvar
              </SaveButton>

              {hasData && (
                <CancelButton
                  type="button"
                  onClick={handleCancel}
                >
                  ✖️ Cancelar
                </CancelButton>
              )}
            </ButtonContainer>
          )}
        </ProfileContainerInfo>
      </motion.div>
    </MainContainer>
  );
};

export default AdditionalInformation;